import React from 'react';
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import { registerSW } from 'virtual:pwa-register';
import App from './App.tsx'
import './index.css'

// Register service worker for PWA and push notifications
if ('serviceWorker' in navigator) {
  registerSW({
    immediate: true,
    onRegistered(registration) {
      console.log('[SW] Service worker registered:', registration);
    },
    onRegisterError(error) {
      console.error('[SW] Service worker registration failed:', error);
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
